export default __webpack_public_path__ + "static/media/160-600.16175a5e.png";